/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeholder_About_HeadlineInputs */

const en_placeholder_about_headline = /** @type {(inputs: Placeholder_About_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Artisans of the Pacific`)
};

const es_placeholder_about_headline = /** @type {(inputs: Placeholder_About_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Artesanos del Pacífico`)
};

const fr_placeholder_about_headline = /** @type {(inputs: Placeholder_About_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Les Artisans du Pacifique`)
};

const de_placeholder_about_headline = /** @type {(inputs: Placeholder_About_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Handwerker des Pazifiks`)
};

const id_placeholder_about_headline = /** @type {(inputs: Placeholder_About_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. Pengrajin Nusantara`)
};

/** @type {(inputs: Placeholder_About_HeadlineInputs) => LocalizedString} */
const ja_placeholder_about_headline = en_placeholder_about_headline;

/** @type {(inputs: Placeholder_About_HeadlineInputs) => LocalizedString} */
const zh_placeholder_about_headline = en_placeholder_about_headline;

/** @type {(inputs: Placeholder_About_HeadlineInputs) => LocalizedString} */
const ar_placeholder_about_headline = en_placeholder_about_headline;

/** @type {(inputs: Placeholder_About_HeadlineInputs) => LocalizedString} */
const it_placeholder_about_headline = en_placeholder_about_headline;

/** @type {(inputs: Placeholder_About_HeadlineInputs) => LocalizedString} */
const ru_placeholder_about_headline = en_placeholder_about_headline;

/** @type {(inputs: Placeholder_About_HeadlineInputs) => LocalizedString} */
const pt_placeholder_about_headline = en_placeholder_about_headline;

/** @type {(inputs: Placeholder_About_HeadlineInputs) => LocalizedString} */
const ko_placeholder_about_headline = en_placeholder_about_headline;

/**
* | output |
* | --- |
* | "e.g. Artisans of the Pacific" |
*
* @param {Placeholder_About_HeadlineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const placeholder_about_headline = /** @type {((inputs?: Placeholder_About_HeadlineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeholder_About_HeadlineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeholder_about_headline(inputs)
	if (locale === "es") return es_placeholder_about_headline(inputs)
	if (locale === "fr") return fr_placeholder_about_headline(inputs)
	if (locale === "de") return de_placeholder_about_headline(inputs)
	if (locale === "ja") return ja_placeholder_about_headline(inputs)
	if (locale === "zh") return zh_placeholder_about_headline(inputs)
	if (locale === "ar") return ar_placeholder_about_headline(inputs)
	if (locale === "id") return id_placeholder_about_headline(inputs)
	if (locale === "it") return it_placeholder_about_headline(inputs)
	if (locale === "ru") return ru_placeholder_about_headline(inputs)
	if (locale === "pt") return pt_placeholder_about_headline(inputs)
	return ko_placeholder_about_headline(inputs)
});